import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-images-list',
  templateUrl: './images-list.component.html',
  styleUrls: ['./images-list.component.css']
})
export class ImagesListComponent implements OnInit {
  constructor() { }
  ngOnInit(): void {
  }
}
